import CustomDropdownField from "@/components/site-builder/modules/CustomFormModule/components/FormFieldMapper/CustomDropdownField";
import { useCustomFormStateOfResidenceOptions } from "@/components/site-builder/modules/CustomFormModule/hooks/useCustomFormStateOfResidenceOptions";
import type { FormFieldProps } from "@/components/site-builder/modules/CustomFormModule/components/FormFieldMapper/types";

export default function CustomResidenceStateField(props: FormFieldProps) {
  const { field } = props;

  const stateOptions = useCustomFormStateOfResidenceOptions();

  return (
    <CustomDropdownField
      field={{ ...field, required: true, options: stateOptions }}
    />
  );
}
